import React from 'react';
import { encode as base64_encode, decode as base64_decode } from 'base-64';

import ComponentSelector from "../ComponentSelector/ComponentSelector";

import './AppComponent.css';
import { inserirCookie, retornarCookie } from '../../services/cookieservice';
import { retornaBuscaBusster } from '../../services/buscaBusster';

const { REACT_APP_URL_INSTANCE,REACT_APP_AUTH_URL_REDIRECT } = process.env;

export default class App extends React.Component {

    state = {
        carregando: true,
        componenteARenderizar: null
    };

    verificaUsuarioLogado = async () => {

        const urlParams = new URLSearchParams(window.location.search);
        const authData = urlParams.get('Auth');
        
        if(authData === '' || !authData){
            return false;
        }
        
        //await validarAuthData();

        inserirCookie('Auth', base64_decode(authData));
        inserirCookie('IdUsuario', retornaBuscaBusster("cd55", base64_decode(authData)));
        inserirCookie('CdAgenteVendas', retornaBuscaBusster("cd3", base64_decode(authData)));

        return true;
    }

    componentDidMount() {

        const urlParams = new URLSearchParams(window.location.search);

        if(this.state.componenteARenderizar == null) {

            const rotasAbertasAoPublico = ["ImpressaoPropostaPage"];

            this.verificaUsuarioLogado()
            .then((res) => {
    
                const usuarioLogado = res;
                if(usuarioLogado) {

                    // Caso não tenha uma propriedade instance, redireciona para a página inicial inicial
                    let url = window.location.href;
                    if (!url.includes('?') || urlParams.get('Instance') == undefined || urlParams.get('Instance') == '') {
                        let redirectTo = base64_encode('NavigationBar,HomePage');
                        urlParams.delete("Instance");
                        document.location.href = REACT_APP_URL_INSTANCE + `${redirectTo}&${urlParams.toString()}`;
                    }
                    
                    // Seleciona o component a ser renderizado de acordo com o que veio pelo usuário
                    const componenteRequisitado = base64_decode(urlParams.get('Instance')).split(',');
                    this.setState({ componenteARenderizar: <ComponentSelector Render={componenteRequisitado}/> });

                } else {

                    const componenteRequisitado = base64_decode(urlParams.get('Instance')).split(',');

                    let acessoARotasLiberadas = rotasAbertasAoPublico.some((rota) => rota === componenteRequisitado[0]);
                    
                    // Seleciona o component a ser renderizado de acordo com o que veio pelo usuário
                    // Ou bloqueia o acesso
                    if(acessoARotasLiberadas)
                        this.setState({ componenteARenderizar: <ComponentSelector Render={componenteRequisitado}/> });
                    else
                    document.location.href = `${REACT_APP_AUTH_URL_REDIRECT}`;
                }

                this.setState({carregando: false});
    
            });

        }

    }

    render() {
        return (
            <div>
                {
                    this.state.carregando &&
                    <div>
                        <div className="app-preloader">
                            <div className="preloader-wrapper active">
                                <div className="spinner-layer">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.carregando &&
                    this.state.componenteARenderizar
                }
            </div>
        );
    }

}